import axios from "axios";

export default {
  get,
  getAggregate,
  getAll,
  getCodeCounts,
  getCodes,
  getCodeStats,
  generateCodes,
  generateCodeSets,
  create,
  update,
  deleteSurvey,
  updateAccessKeySettings,
  getCodeDetail,
  patchCode,
  deleteCode,
  deleteCodes,
  downloadCodes,
  downloadResponses,
  saveResponse,
  refreshAggregates
};

const serviceRootUrl = (tenantId) => `/api/${tenantId}/surveys`;

export function getAll(tenantId, portal = false) {
  return new Promise((resolve, reject) => {
    let path = serviceRootUrl(tenantId);

    if (portal) path += '?portal=true';

    axios.get(path).then((result) => {
      resolve(
        result.map((x) => {
          x.startDate = x.startDate.substring(0, x.startDate.indexOf("Z"));
          x.endDate = x.endDate.substring(0, x.endDate.indexOf("Z"));
          return x;
        })
      );
    }, reject);
  });
}

export function get(tenantId, surveyId, slim) {
  return axios.get(
    `${serviceRootUrl(tenantId)}/${surveyId}${slim ? "/slim" : ""}`
  );
}

export function create(tenantId, survey) {
  if (survey.tenantId && survey.tenantId != tenantId)
    throw "Invalid 'tenantId'.";

  return axios.post(`${serviceRootUrl(tenantId)}/create`, survey);
}

export function update(tenantId, surveyId, survey) {
  if (survey.id && survey.id != surveyId) throw "Invalid 'surveyId'.";

  if (survey.tenantId && survey.tenantId != tenantId)
    throw "Invalid 'tenantId'.";

  return axios.post(`${serviceRootUrl(tenantId)}/${surveyId}`, survey);
}

export function deleteSurvey(tenantId, id) {
  return axios.post(`${serviceRootUrl(tenantId)}/${id}/delete`, {
    tenantId,
    id,
  });
}

export function updateAccessKeySettings(
  tenantId,
  surveyId,
  { accessKeyLength, accessKeyChars, accessKeyUseType }
) {
  return axios.post(
    `${serviceRootUrl(tenantId)}/${surveyId}/AccessKeySettings`,
    {
      accessKeyLength,
      accessKeyChars,
      accessKeyUseType,
    }
  );
}

export function refreshAggregates(tenantId, surveyId) {
  return axios.post(`${serviceRootUrl(tenantId)}/${surveyId}/RefreshAggs`, {});
}

export function getAggregate(tenantId, surveyId, key, groupedBy) {
  return axios.post(`${serviceRootUrl(tenantId)}/${surveyId}/Aggregate`, {
    key,
    groupedBy,
  });
}

export function getCodeStats(tenantId, surveyId) {
  return axios.get(`${serviceRootUrl(tenantId)}/${surveyId}/Stats/Codes`);
}

export function getCodeCounts(tenantId, surveyId) {
  return axios.get(`${serviceRootUrl(tenantId)}/${surveyId}/Stats/CodeCounts`);
}

export function getCodes(tenantId, surveyId, filters) {
  return axios.post(`${serviceRootUrl(tenantId)}/${surveyId}/codes`, {
    filters,
  });
}

export function deleteCodes(tenantId, surveyId, metaData) {
  return axios.post(`${serviceRootUrl(tenantId)}/${surveyId}/codes/delete`, {
    metaData,
  });
}

export function generateCodes(
  tenantId,
  surveyId,
  codeCounts,
  workflow,
  existingCodeHandler
) {
  return axios.post(`${serviceRootUrl(tenantId)}/${surveyId}/codes/generate`, {
    codeCounts,
    workflow,
    existingCodeHandler,
  });
}

export function generateCodeSets(
  tenantId,
  surveyId,
  file,
  workflow,
  existingCodeHandler
) {
  let formData = new FormData();
  formData.append("file", file);
  formData.append("workflow", workflow);
  formData.append("existingCodeHandler", existingCodeHandler);

  return axios.post(
    `${serviceRootUrl(tenantId)}/${surveyId}/codes/batch`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
}

export function getCodeDetail(tenantId, surveyId, code) {
  return axios.get(`${serviceRootUrl(tenantId)}/${surveyId}/codes/${code}`);
}

export function patchCode(tenantId, surveyId, codeBankItem) {
  return axios.patch(
    `${serviceRootUrl(tenantId)}/${surveyId}/codes/${codeBankItem.id}`,
    codeBankItem
  );
}

export function deleteCode(tenantId, surveyId, codeBankItem) {
  return axios.delete(
    `${serviceRootUrl(tenantId)}/${surveyId}/codes/${codeBankItem.id}`
  );
}

export function downloadCodes(tenantId, surveyId, filters = []) {
  return axios({
    url: `${serviceRootUrl(tenantId)}/${surveyId}/codes/download`,
    method: "POST",
    responseType: "blob", // important
    data: { filters },
  }).then(
    (response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${surveyId}_AccessKeys.csv`); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    (error) => {
      console.warn(error);
    }
  );
}

export function downloadResponses(tenantId, surveyId, filters = []) {
  return axios({
    url: `${serviceRootUrl(tenantId)}/${surveyId}/responses/download`,
    method: "POST",
    responseType: "blob", // important
    data: { filters },
  })
}

export function saveResponse(tenantId, surveyId, response) {
  return axios.post(
    `${serviceRootUrl(tenantId)}/${surveyId}/responses`,
    response
  );
}
